import { render, staticRenderFns } from "./UserStrategyStats.vue?vue&type=template&id=20a1b6e3&scoped=true&"
import script from "./UserStrategyStats.vue?vue&type=script&lang=js&"
export * from "./UserStrategyStats.vue?vue&type=script&lang=js&"
import style0 from "./UserStrategyStats.vue?vue&type=style&index=0&id=20a1b6e3&lang=scss&scoped=true&"
import style1 from "./UserStrategyStats.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1b6e3",
  null
  
)

export default component.exports